import { DateTime } from 'luxon'

import { Box, Comment as CommentBase } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import type { CommentModel } from '@models/types'

import useComment from '@hooks/useComment'
import useAttachments from '@hooks/useAttachments'
import { useRelations as useUserRelations } from '@hooks/useUser'

import Attachment from './Attachment'

interface CommentWithAttachmentsProps {
  boxProps?: object,
  comment: Partial<CommentModel>,
  hasLatestAttachment: boolean,
  isLastComment: boolean,
}

const CommentWithAttachments = (props: CommentWithAttachmentsProps) => {
  const {
    boxProps, comment, hasLatestAttachment, isLastComment,
  } = props

  const commentPayload = useComment(comment)
  const { comment: { body, public: isPublic }, user } = commentPayload

  const { filteredAttachments, hasFilteredAttachments } = useAttachments({
    filters: {
      attachable_id: comment.id,
      attachable_type: 'Comment',
    },
  })

  const { image } = useUserRelations(user)

  const createdDateString = digObject(comment, 'dates.created.date_time')

  return (
    <>
      <CommentBase
        boxProps={{
          borderBottom: hasFilteredAttachments || isLastComment ? 'none' : '1px dashed',
          marginBottom: hasFilteredAttachments || isLastComment ? 0 : 'large',
          ...boxProps,
        }}
        callbacks={{ deleteComment: () => undefined }}
        // @ts-expect-error TS2322
        commentBody={body}
        commentTime={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
        fullName={user.full_name}
        // @ts-expect-error TS2339
        imageUrl={image.thumb_url}
        // @ts-expect-error TS2322
        isPublic={isPublic}
      />

      {hasFilteredAttachments && (
        <Box
          borderBottom={isLastComment ? 'none' : '1px dashed'}
          borderColor="lineColor"
          marginBottom="large"
        >
          <Box flexDirection="column" marginBottom="large" marginLeft="45px" width="fit-content">
            {filteredAttachments.reverse().map(attachment => (
              <Attachment key={attachment.id} attachment={attachment} outdated={!hasLatestAttachment} />
            ))}
          </Box>
        </Box>
      )}
    </>
  )
}

export default CommentWithAttachments
